/**
 * @constructor
 * 5*张量，由于第一个数字是5，回调到int类，在abstract.js的方法binary_op_调换它们的先后顺序
 * @extends Sk.builtin.tensor
 */
Sk.builtin.tensor = Sk.abstr.buildNativeClass("tensor", {
    constructor: function tensor(tensor) {
        this.$tensor = tensor;
    },
    slots: {
        tp$getattr(pyName, canSuspend) { //获取属性
            const name = Sk.ffi.remapToJs(pyName);
            if(name === "shape"){
                return Sk.ffi.remapToPy(this.$tensor.shape);
            }else if(name === "dtype"){
                return Sk.ffi.remapToPy(this.$tensor.dtype);
            }else if(name === "name"){
                return Sk.ffi.remapToPy(this.$tensor.name);
            }else if(name === "data"){//torch它会返回与原始张量相同数据，但不会构建计算图
                let res = new Sk.builtin.tensor(this.$tensor);
                res.$grad = this;//清零用
                return res;
            }else if(name === "device"){//随便给的
                return Sk.ffi.remapToPy("virtual");
            }else if(name === "grad"){
                return this.$grad!==undefined?this.$grad:Sk.builtin.none.none$;
            }else if(name === "is_leaf"){
                return this.$is_leaf!==undefined?this.$is_leaf:Sk.builtin.bool.false$;
            }else if(name === "grad_fn"){
                return this.$grad_fn!==undefined?this.$grad_fn:Sk.builtin.none.none$;
            }else if(name === "requires_grad"){
                return this.$requires_grad!==undefined?Sk.ffi.remapToPy(this.$requires_grad):Sk.builtin.bool.false$;
            }	
			
            return Sk.generic.getAttr.call(this, pyName, canSuspend);
        },
        tp$setattr(pyName, value) {
            const name = Sk.ffi.remapToJs(pyName);
            if (name === "requires_grad") {
                callTorchGradTensor(this, value);
            }else if(name === "data"){//清除求梯度信息		
                this.$tensor = value.$tensor;
            } else {			
                return Sk.generic.setAttr.call(this, pyName, value);
            }
        },		
        tp$doc:
            "tensor(func, *iterables) --> tensor object\n\nMake an iterator that computes the function using arguments from\neach of the iterables.  Stops when the shortest iterable is exhausted.",
        tp$new: Sk.generic.new,
        $r() {//print输出
            return new Sk.builtin.str(this.$tensor.toString());
        },		
        nb$add(other){
            return this.calTensorResult(other, "add");
        },
        nb$subtract(other){
            return this.calTensorResult(other, "sub");
        },
        nb$multiply(other){
            return this.calTensorResult(other, "mul");
        },
        nb$matrix_multiply(other){
            return this.callNormalMethods2(other, "matmul");//这个matMul是js名称，matmul是Python名称
        },		
        nb$divide(other){
            return this.calTensorResult(other, "div");
        },
        nb$floor_divide(other){
            return this.calTensorResult(other, "floorDiv");
        },
        nb$remainder(other){
            return this.calTensorResult(other, "mod");
        },
        nb$power(other){
            return this.calTensorResult(other, "pow");
        },
        mp$subscript(other) {//切片 __getitem__
            return this.tensor$subscript(other);
        },
        mp$ass_subscript(index, value) {//切片 "__setitem__", "__delitem__"
            if (value === undefined) {
                this.del$subscript(index);
            } else {
                this.ass$subscript(index, value);
            }
        },		
        nb$negative() {//相反数
            return new Sk.builtin.tensor(Sk.$tf.neg(this.$tensor));
        },	
        ob$eq: compareSlot((v, w) => v == w),
        ob$ne: compareSlot((v, w) => v != w),
        ob$gt: compareSlot((v, w) => v > w),
        ob$ge: compareSlot((v, w) => v >= w),
        ob$lt: compareSlot((v, w) => v < w),
        ob$le: compareSlot((v, w) => v <= w),	
    },
    methods: /** @lends {Sk.builtin.tensor.prototype}*/ {
        reshape: callNormalMethods("reshape"),		
        numpy: callNormalMethods("numpy"),	
        read_value: {
            $meth() {
                return Sk.ffi.remapToPy(this.$tensor.arraySync());
            },
            $flags: { NoArgs: true },
            $textsig: "($self, /)",
            $doc: "Return value of the tensor.",
        },		
        assign: tensor_assign(),
        copy_: tensor_assign(),
        assign_add: {
            $meth(item) {
                let tem = Sk.$tf.add(this.$tensor, this.normalToTensor(item).$tensor);
                this.$tensor.assign(tem);
                return new Sk.builtin.tensor(tem);
            },
            $flags: { OneArg: true },
            $textsig: "($self, object, /)",
            $doc: "Return value of the tensor.",
        },
        assign_sub: {
            $meth(item) {
                let tem = Sk.$tf.sub(this.$tensor, this.normalToTensor(item).$tensor);
                this.$tensor.assign(tem);
                return new Sk.builtin.tensor(tem);
            },
            $flags: { OneArg: true },
            $textsig: "($self, object, /)",
            $doc: "Return value of the tensor.",
        },		
        sqrt: {
            $meth() {
                let ten = Sk.$tf.sqrt(this.$tensor);
                return new Sk.builtin.tensor(ten);
            },
            $flags: { NoArgs: true },
            $textsig: "($self, /)",
            $doc: "Return value of the tensor.",
        },
        sum: callNormalMethods("sum"),
        mean: callNormalMethods("mean"),
        var: {//方差
            $meth() {
                let ten = Sk.$tf.moments(this.$tensor);
                return new Sk.builtin.tensor(ten)[1];
            },
            $flags: { NoArgs: true },
            $textsig: "($self, /)",
            $doc: "Return value of the tensor.",
        },		
        pow: callNormalMethods("pow"),//下面的方法是PyTorch里面的
        max: {
            $meth(args, kwargs) {
                return this.maxOrMin("max", args, kwargs);
            },
            $flags: { FastCall: true},
            $textsig: "($self, /)",
            $doc: "Return value of the tensor.",
        },
        min: {
            $meth(args, kwargs) {
                return this.maxOrMin("min", args, kwargs);
            },
            $flags: {FastCall: true },
            $textsig: "($self, /)",
            $doc: "Return value of the tensor.",
        },
        argmax: {
            $meth(args, kwargs) {
                return this.maxOrMin("argMax", args, kwargs);
            },
            $flags: {FastCall: true},
            $textsig: "($self, /)",
            $doc: "Return value of the tensor.",
        },
        argmin: {
            $meth(args, kwargs) {
                return this.maxOrMin("argMin", args, kwargs);
            },
            $flags: {FastCall: true},
            $textsig: "($self, /)",
            $doc: "Return value of the tensor.",
        },		
        floor: callNormalMethods("floor"),
        ceil: callNormalMethods("ceil"),
        trunc: callNormalMethods("trunc"),
        frac: callNormalMethods("frac"),
        round: callNormalMethods("round"),
        size: {
            $meth(index) {                
                if(Sk.builtin.checkInt(index)){
                    return Sk.ffi.remapToPy(this.$tensor.shape[Sk.ffi.remapToJs(index)]);
                }else{
                    return Sk.ffi.remapToPy(this.$tensor.shape);
                }
            },
            $flags: { MinArgs: 0, MaxArgs: 1 },
            $textsig: null,
            $doc: "Return value of the tensor.",
        },		
        resize_: {
            $meth(args, kwargs) {
                let shape = Sk.ffi.remapToJs(args);
                let count = shape.reduce((accumulator, currentValue) => accumulator * currentValue, 1);
                let ten = Sk.$tf.tensor(this.$tensor.dataSync().slice(0, count));
                this.$tensor = ten.reshape(shape);				
                return this;
            },
            $flags: {FastCall: true},
            $textsig: null,
            $doc: "Return value of the tensor.",
        },	
        new_ones: {
            $meth(args, kwargs) {
                args = Sk.ffi.remapToJs(args);
                let dtype = Sk.ffi.remapToJs(kwargs["dtype"]);
                if(args.length==0){
                    return new Sk.builtin.tensor(Sk.$tf.onesLike(this.$tensor, dtype));
                }else{
                    return new Sk.builtin.tensor(Sk.$tf.ones(args, dtype));
                }
            },
            $flags: {FastCall: true},
            $textsig: null,
            $doc: "Return value of the tensor.",
        },
        len: {
            $meth() {
                return Sk.ffi.remapToPy(this.$tensor.shape[0]);
            },
            $flags: { NoArgs: true },
            $textsig: "($self, /)",
            $doc: "Return shape of the tensor.",
        },		
        int: {
            $meth() {
                return new Sk.builtin.tensor(Sk.$tf.cast(this.$tensor, "int32"));
            },
            $flags: { NoArgs: true },
            $textsig: "($self, /)",
            $doc: "Return shape of the tensor.",
        },
        float: {
            $meth() {
                return new Sk.builtin.tensor(Sk.$tf.cast(this.$tensor, "float32"));
            },
            $flags: { NoArgs: true },
            $textsig: "($self, /)",
            $doc: "Return shape of the tensor.",
        },
        half: {
            $meth() {
                return new Sk.builtin.tensor(Sk.$tf.cast(this.$tensor, "float32"));
            },
            $flags: { NoArgs: true },
            $textsig: "($self, /)",
            $doc: "Return shape of the tensor.",
        },		
        double: {
            $meth() {
                return new Sk.builtin.tensor(Sk.$tf.cast(this.$tensor, "float32"));
            },
            $flags: { NoArgs: true },
            $textsig: "($self, /)",
            $doc: "Return shape of the tensor.",
        },
        median: callNormalMethods("median"),
        view: callNormalMethods("view"),	
        to: {
            $meth(args, kwargs) {
                args = Sk.ffi.remapToJs(args);
                if(args.length>1){
                    return new Sk.builtin.tensor(Sk.$tf.cast(this.$tensor, args[1]));
                }else{
                    return this;
                }
            },
            $flags: {FastCall: true},
            $textsig: null,
            $doc: "Return value of the tensor.",
        },
        cpu: {
            $meth() {			
                return this;
            },
            $flags: { NoArgs: true },
            $textsig: "($self, /)",
            $doc: "Return shape of the tensor.",
        },		
        cuda: {
            $meth() {			
                return this;
            },
            $flags: { NoArgs: true },
            $textsig: "($self, /)",
            $doc: "Return shape of the tensor.",
        },
        item: {
            $meth() {
                return Sk.ffi.remapToPy(this.$tensor.arraySync());
            },
            $flags: { NoArgs: true },
            $textsig: "($self, /)",
            $doc: "Return value of the tensor.",
        },
        detach: {
            $meth() {
                return new Sk.builtin.tensor(this.$tensor.clone());
            },
            $flags: { NoArgs: true },
            $textsig: "($self, /)",
            $doc: "Return value of the tensor.",
        },
        zero_: {//清空梯度
            $meth() {
                this.$tensor = Sk.builtin.none.none$;
                if(this.$grad!==undefined){
                    this.$grad.$tensor = Sk.builtin.none.none$;
                }
            },
            $flags: { NoArgs: true },
            $textsig: "($self, /)",
            $doc: "Return value of the tensor.",
        },		
        squeeze: callNormalMethods("squeeze"),	
        normal_: {
            $meth(args, kwargs) {
                args = Sk.ffi.remapToJs(args);
                if(this.$layer===undefined||this.$layer.getWeights().length==0){
                    return Sk.builtin.none.none$;
                }
                let weights = this.$layer.getWeights()[0];
                if(weights){
                    weights = Sk.$tf.randomNormal(weights.shape, args[0], args[1]);
                    this.$layer.setWeights([weights]);
                }				
                return Sk.builtin.none.none$;
            },
            $flags: {FastCall: true},
            $textsig: null,
            $doc: "Return value of the tensor.",
        },
        requires_grad_: {//只修改requires_grad
            $meth(item) {
                callTorchGradTensor(this, item);
                return Sk.builtin.none.none$;
            },
            $flags: { OneArg: true },
            $textsig: "($self, object, /)",
            $doc: "Return value of the tensor.",
        },		
        t: callNormalMethods("transpose"),
        permute: callNormalMethods("permute"),
        transpose: callNormalMethods("transpose"),
        gather: callNormalMethods("gather"),
        scatter_: callNormalMethods("scatter_"),
        clamp: callNormalMethods("clamp"),
        backward: callNormalMethods("backward"),
        register_hook: callNormalMethods("register_hook"),
    },	
    proto: /** @lends {Sk.builtin.tensor.prototype}*/ {
        normalToTensor,
        calTensorResult,
        callNormalMethods2,
        maxOrMin,
        tensorSlice,
        tensor$inRange(i, size, msg) {
            if (i < 0) {
                i += size;
            }
            if (i >= 0 && i < size) {
                return i;
            }
            throw new Sk.builtin.IndexError(msg);
        },
        tensor$subscript(other) {//切片 
            let datas = this.$tensor.arraySync();		
            if (Sk.misceval.isIndex(other)) { // a[0][1]               
                let i = Sk.misceval.asIndexSized(other, Sk.builtin.IndexError);
                i = this.tensor$inRange(i, datas.length, "list index out of range");				
                return new Sk.builtin.tensor(Sk.$tf.tensor(datas[i]));
            } else if (other instanceof Sk.builtin.slice) {//a[::-1]
                const ret = [];
                other.sssiter$(datas.length, (i) => {
                    ret.push(datas[i]);
                });
                return new Sk.builtin.tensor(Sk.$tf.tensor(ret));
            }
            return this.tensorSlice(datas, other);
        },
        ass$subscript(index, value) {
            index = Sk.ffi.remapToJs(index);		
            value = value.$tensor;
            let indices;
            if(!Array.isArray(index)){//1个整数
                if(this.$tensor.shape.length==1){//1维
                    index = [index];
                }else{//只处理二维，其他复制情况？
                    let arr = [];
                    for(let i=0;i<this.$tensor.shape[1];i++){
                        arr.push([index, i]);
                    }
                    index = arr;
                }      
            }			
            if(!Array.isArray(index[0])){//1维
                value = Sk.$tf.tensor1d(value.dataSync(), this.$tensor.dtype);
                indices = Sk.$tf.tensor1d(index, "int32");
            }else{//2维，多维没有测过
                let dim = countDimensions(index);
                let func = eval("Sk.$tf.tensor"+dim+"d");//索引只能指定维度，不能直接用tensor
                let shape = func(index).shape;//获取形状
                indices = func(index, shape, "int32");
            }
            if(this.$tensor.dtype!==value.dtype){
                value = Sk.$tf.cast(value, this.$tensor.dtype);
            }
            this.$tensor = Sk.$tf.tensorScatterUpdate(this.$tensor, indices, value);
        },		
        del$subscript(index) {//未实现
            
        },	
    },		
});

function calTensorResult(other, op){
    var tensor;
    if (typeof Sk_calTensorResult!="undefined" && Sk_calTensorResult instanceof Function) {//求导用到
        tensor = Sk_calTensorResult(this, other, op);//tensorflow.js里面
    }
    return tensor;
}

function maxOrMin(op, args, kwargs){
    var tensor;
    if (typeof Sk_maxOrMin!="undefined" && Sk_maxOrMin instanceof Function) {
        let oldkwa = {};
        if (kwargs) {
            for (let i = 0; i < kwargs.length; i += 2) {
                oldkwa[new Sk.builtin.str(kwargs[i])] = Sk.ffi.remapToJs(kwargs[i + 1]);
            }
        }
        args.unshift(this);		
        tensor = Sk_maxOrMin(op, args, oldkwa);//torch.js里面
    }
    return tensor;
}

//针对普通的数据
function normalToTensor(other){
    if(other.$tensor === undefined){
        other = new Sk.builtin.tensor(Sk.$tf.tensor(Sk.ffi.remapToJs(other)));
    }
    return other;
}

function tf$isAllIntegers(other) {
    let arr = Sk.ffi.remapToJs(other);
    return arr.every((num) => Number.isInteger(num));
}
//切片
function tensorSlice(datas, other){
    if (Array.isArray(other.v)) {	
        if (tf$isAllIntegers(other)) {// a[0,1,2]
            let arrs = "";//设置值用
            let res = Sk.misceval.chain(
                Sk.misceval.iterFor(Sk.abstr.iter(other), (i) => {
                    datas = datas[i];
                    arrs +="["+i+"]";
                }),
                () => datas
            );
            res = Sk.$tf.tensor(res);
            if(this.$tensor.assign){//同时设置赋值的数据
                res = Sk.$tf.variable(res);
                res = new Sk.builtin.tensor(res);
                res.$ptensor = this.$tensor;
                res.$arrs = arrs;
                return res;
            }else{
                return new Sk.builtin.tensor(res);
            }
        }else {
            var [tfBegin, tfSize] = pythonMultiSliceToTFSlice(Sk.ffi.remapToJs(other), this.$tensor.shape);
            var tensor = Sk.$tf.slice(this.$tensor, tfBegin, tfSize);
            if(Sk.$isTorch!==undefined && Sk.$isTorch){
                let isOne = tensor.shape[0]==1;//第一个是1，不要剔除
                tensor = tensor.squeeze();//torch里面的张量切片对去掉单维的，比如[32,1,32]变成[32,32]
                if(isOne){//补回去
                    tensor = Sk.$tf.expandDims(tensor, 0);
                }
            }
            return new Sk.builtin.tensor(tensor);
        }
    }
}
//主要有chatgpt生成
function pythonMultiSliceToTFSlice(slices, shape) {
    const tfBegin = [];
    const tfSize = [];
    let ellipsisIndex = -1;
    let isTimeStep = false;//[:,t,:,:,:]
    slices.forEach((slice, i) => {
        if (slice === "...") {
            ellipsisIndex = i;
            return;
        }
        if(i==0&&slice.start&&!slice.start.v&&!slice.step.v&&!slice.stop.v){
            isTimeStep = true;
        }else if(i==1&&isTimeStep&&!Sk.builtin.checkInt(slice)){
            isTimeStep = false;
        }else if(i>1&&isTimeStep&&(!slice.start|| slice.start.v||slice.step.v||slice.stop.v)){
            isTimeStep = false;
        }
        let begin,end;
        if(slice.start){
            begin = slice.start.v ? parseInt(slice.start.v) : undefined;
            end = slice.stop.v ? parseInt(slice.stop.v) : undefined;
        } else {//单独一个数字
            begin = parseInt(slice);
            end = begin + parseInt(slice);
        }
        // 处理负索引
        if (begin !== undefined && begin < 0){
            begin = shape[i] + begin;
        }
        if (end !== undefined && end < 0){
            end = shape[i] + end;
        }
        // 处理省略号
        if (begin === undefined && end === undefined) {
            begin = 0;
            end = shape[i];
        } else if (begin === undefined) {
            begin = 0;
        } else if (end === undefined) {
            end = shape[i];
        }
        tfBegin.push(begin);
        tfSize.push(end - begin);
    });
    // 处理省略号
    if (ellipsisIndex !== -1) {
        const remainingDimensions = shape.length - slices.length + 1;
        const begin = ellipsisIndex;
        const end = ellipsisIndex + remainingDimensions;
        tfBegin.splice(begin, 0, 0);
        tfSize.splice(begin, 0, ...shape.slice(ellipsisIndex, end));
    }
    if(isTimeStep){
        tfSize[1] = 1;//特殊处理？
    }
    return [tfBegin, tfSize];
}

function compareSlot(number_func) {
    return function (other) {// 不支持tensor里面比较方法的返回值
        let v = this.$tensor.dataSync()[0];
        let w = other;
        if(other.$tensor) {
            w = other.$tensor.dataSync()[0];
        }
        return number_func(v, w);
    };
}
//计算数组几维
function countDimensions(arr) {
    if (!Array.isArray(arr)) {
        return 0;
    }
    const subArrayDimensions = arr.map(countDimensions);
    return Math.max(...subArrayDimensions) + 1;
}

function callNormalMethods(methodName){
    return {
        $meth(args, kwargs) {
            if (Sk.tensorMod!=="undefined") {
                args.unshift(this);
                return Sk.misceval.callsimOrSuspendArray(eval("Sk.tensorMod."+methodName), args, kwargs);
            }
            return Sk.builtin.none.none$;
        },
        $flags: {FastCall: true},
        $textsig: null,
        $doc: "Return value of the tensor.",
    };
}
//以后考虑都换成这种
function callNormalMethods2(other, methodName) {
    if (Sk.tensorMod!=="undefined") {
        return Sk.misceval.callsimOrSuspend(eval("Sk.tensorMod."+methodName), this, other);
    }
}

function tensor_assign(){
    return {
        $meth(item) {
            if(this.$ptensor !==undefined){
                this.$datas = this.$ptensor.arraySync();
                eval("this.$datas"+this.$arrs+"="+Sk.ffi.remapToJs(item));
                item = this.$datas;
                this.$tensor = this.$ptensor;
            }
            let res = this.normalToTensor(item).$tensor;
            this.$tensor.assign(res);
            return new Sk.builtin.tensor(res);
        },
        $flags: { OneArg: true },
        $textsig: "($self, object, /)",
        $doc: "Return value of the tensor.",
    };
}

function callTorchGradTensor(that, value){
    value = Sk.ffi.remapToJs(value);
    if (value && typeof torchGradTensor!="undefined" && torchGradTensor instanceof Function) {		
        return torchGradTensor([that], {"requires_grad":true});//设置求导属性
    }
}

Sk.exportSymbol("Sk.builtin.tensor", Sk.builtin.tensor);
